import React from 'react'
import { createPortal } from 'react-dom'
import { useApp } from '../context/AppContext'
import { minutesToTime } from '../catalog/format'
import { shortDay } from '../calendar/timeOff'
import { useDialog } from '../hooks/useDialog'
import './Sheet.css'
import './Booking.css'

// TapChoiceSheet asks what a tap on free calendar time is for: a booking, or
// time blocked off. Either opens its own sheet already filled in.
export default function TapChoiceSheet() {
  const { state, dispatch } = useApp()
  const tap = state.tapChoice
  const close = () => dispatch({ type: 'CLOSE_SHEET' })
  const dialogRef = React.useRef<HTMLDivElement>(null)
  useDialog(dialogRef, close)
  if (!tap) return null

  const title = `${shortDay(tap.date)} · ${minutesToTime(tap.startMinute)}`

  const sheet = (
    <div className="sheet-overlay" onClick={(e) => { e.stopPropagation(); close() }}>
      <div ref={dialogRef} className="sheet-content" role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="sheet-handle"></div>
        <div className="sheet-header">
          <h2>{title}</h2>
        </div>
        <div className="sheet-stack">
          <button
            type="button"
            className="booking-option"
            onClick={() => dispatch({ type: 'OPEN_BOOK_SHEET', payload: { date: tap.date, startMinute: tap.startMinute } })}
          >
            <span className="booking-option__title">Book a client</span>
          </button>
          <button type="button" className="booking-option" onClick={() => dispatch({ type: 'OPEN_BLOCK_SHEET', payload: tap })}>
            <span className="booking-option__title">Block time</span>
          </button>
          <button type="button" className="btn btn-secondary btn-block" onClick={close}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )

  const host = typeof document === 'undefined' ? null : document.querySelector('.app-container')
  return host ? createPortal(sheet, host) : sheet
}
